import { API_MASTER_DATA } from '../../service/index'
import router from '../../router'
import axios from 'axios'

export default {
  state: {
    MenuListAll: null,
    MenuDetail: null,
    MenuUUID: null
  },
  mutations: {
    setMenuListAll (state, list) {
      state.MenuListAll = list
    },
    setMenuDetail (state, list) {
      state.MenuDetail = list
    }
  },
  actions: {
    setScrollMenuPosition ({state}, payload) {
      state.MenuUUID = payload
    },
    async getMenuListByBranch ({commit}, payload) {
      const menus = await axios({
        method: 'GET',
        url: API_MASTER_DATA + 'restaurants/' + payload.restaurant_uuid + '/branches/' + payload.branch_uuid + '/menus',
        responseType: 'json',
      }).then((response) => {
        return (response.data.meta.status == 200) ? response.data.data.menus : []
      }).catch(() => {
        return []
      })
      commit('setMenuListAll', menus)
    },
    async getMenuDetail(_context, payload) {
      return axios({
        method: 'GET',
        url: API_MASTER_DATA + 'restaurants/' + payload.restaurant_uuid + '/branches/' + payload.branch_uuid + '/menus/' + payload.menu_uuid,
        responseType: 'json',
      }).then((response) => {
        return (response.data.meta.status == 200) ? response.data.data : []
      }).catch(() => {
        return []
      })
    },
    async updateMenuDetail ({commit, state, dispatch}, payload) {
      const menu = await dispatch('getMenuDetail', payload)
      commit('setMenuDetail', menu)
      return menu
    }
  },
  getters: {
    MenuListAll (state) {
      return state.MenuListAll
    },
    MenuDetail (state) {
      return state.MenuDetail
    },
    MenuUUID (state) {
      return state.MenuUUID
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/menu/index.js